import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sms"}/>
}
